export interface CsvColumn<T> {
  header: string
  value: (row: T) => string | number | null | undefined
}

const escapeCell = (value: string | number | null | undefined) => {
  if (value === null || value === undefined) return ''
  const cell = String(value)
  return /[",\r\n]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell
}

export const toCsv = <T>(columns: CsvColumn<T>[], rows: T[]) => {
  const header = columns.map((column) => escapeCell(column.header)).join(',')
  const body = rows.map((row) =>
    columns.map((column) => escapeCell(column.value(row))).join(','),
  )
  return [header, ...body].join('\r\n')
}

export const downloadCsv = <T>(
  filename: string,
  columns: CsvColumn<T>[],
  rows: T[],
) => {
  // Excel only detects UTF-8 from a BOM. Without it Greek and Turkish column
  // headers arrive mangled.
  const blob = new Blob([`\uFEFF${toCsv(columns, rows)}`], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
